import decimal from 'decimal.js'

/**
 * 充值相关 Utils
 */
export const RechargeUtils = Object.freeze({
  /**
   * 计算应付金额及手续费
   * @param rechargeMoney {number} 充值金额
   * @param feeRate {number} 线上手续费费率(总), 单位 %, 一般为千六(0.6)
   * @param feeRateUser {number} 线上手续费费率(用户承担部分), 单位 %
   * @returns {{userFee: number, corpFee: number, total: *, recharge: *, totalFee: number}}
   */
  calculateTransactionFee(rechargeMoney, feeRate, feeRateUser) {
    // NOTE: 设置四舍五入方式, ROUND_HALF_UP 对应后端 C# 的 AwayFromZero
    decimal.set({rounding: decimal.ROUND_HALF_UP});

    const dps = 2,
      rechargeMny = decimal(rechargeMoney || 0).toDP(dps),
      rates = decimal(feeRate).div(100),
      ratesUser = decimal(feeRateUser).div(100),
      one = decimal(1),
      minFee = decimal(0.01);

    // 应付金额 = 充值金额 / (1 - 总费率)
    let total = rechargeMny.div(one.sub(rates)).toDP(dps);
    // 手续费 = MAX(最小手续费0.01, 应付金额 - 充值金额), 费率为 0 或应付为 0 时手续费也应为 0
    const fee = !feeRate || total.eq(0) ? decimal(0) : decimal.max(minFee, total.sub(rechargeMny));
    // 用户承担手续费 = MAX(最小手续费0.01, 手续费 * (用户费率 / 总费率)), 用户费率为 0 或手续费为 0 时用户承担手续费也应为 0
    const userFee = !feeRateUser || fee.eq(0) ? decimal(0) : decimal.max(minFee, fee.mul(ratesUser.div(rates)).toDP(dps));
    // 应付金额 = 充值金额 + 手续费(用户), 此处重算 total 是为避免手续费不足 0.01 时应付金额不对
    total = rechargeMny.add(userFee);
    // 实际总手续费 = 应付金额 * 总费率
    const merFee = !feeRate || total.eq(0) ? decimal(0) : decimal.max(minFee, total.mul(rates).toDP(dps));
    // 物业承担手续费 = 实际总手续费 - 用户承担手续费
    const corpFee = merFee.sub(userFee);

    return {
      /** 应付金额 */
      total: total.toDP(dps).toNumber(),
      /** 充值金额 */
      recharge: rechargeMny.toDP(dps).toNumber(),
      /** 使用线上手续费费率(总)计算出的手续费, 用于计算用户承担部分, 非实际手续费 */
      feeRateFee: fee.toDP(dps).toNumber(),
      /** 实际手续费(总) */
      totalFee: merFee.toDP(dps).toNumber(),
      /** 实际手续费(用户) */
      userFee: userFee.toDP(dps).toNumber(),
      /** 实际手续费(物业) */
      corpFee: corpFee.toDP(dps).toNumber()
    };
  }
});
